<!--
 * =====================================================================
 * 작 업 명  : 회원 임시 비밀번호 발급
 * 파 일 명  : FindPwd.vue
 * 변경이력
 * 2022-02-09 / 경다찬 / 최초작성
 * 2022-03-04 / 경다찬 / 디자인 변경 및 기능추가
 * 2023-02-17 / 정태화 / 화면크기 수정, 로딩바 처리, 이메일 인증코드 체크 수정, 비밀번호 유효성 체크 수정
 * =====================================================================
 -->
<template>
  <!-- 1단계 -->
  <div class="stepOne fixed-layout" v-show="one">

    <div class="content">
      <div class="title mt-3 mb-4">
        <p class="h2"><b>Find your password</b></p>
      </div>

      <div class="text mb-4">
        <p class="h6">Enter your username.</p>
      </div>

      <div class="form-floating mb-4">
        <input
            type="text"
            class="form-control"
            id="step-1-user-id"
            v-model="user.USER_ID"
            required
        />
        <label for="step-1-user-id">Username</label>
      </div>

      <div ref="one" class="check red" role="alert">&nbsp;</div>
    </div>

    <div class="buttons">
      <div class="row">
        <div class="col mb-3">
          <button
              type="button"
              class="btn btn-outline-dark btn-lg rounded-pill w-100"
              @click="cancelClick(), closeWebView()"
          >
            Cancel
          </button>
        </div>

        <div class="col mb-3">
          <button
              type="button"
              class="btn btn-dark btn-lg rounded-pill w-100"
              :disabled="user.USER_ID === ''"
              @click="findPwdClick"
          >
            <span
                class="spinner-border spinner-border-sm"
                v-if="loading.step1"
            ></span>
            Send
          </button>
        </div>
      </div>
    </div>

  </div>

  <!-- 2단계 -->
  <div class="stepTwo fixed-layout" v-show="two">
    <div class="content">
      <div class="title mt-3 mb-4">
        <p class="h2"><b>Verify it's you</b></p>
      </div>

      <div class="text mb-4">
        <p class="h6">We have sent you an email with a verification code.</p>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" readonly v-model="user.USER_ID" />
        <label>Username</label>
      </div>

      <div class="form-floating mb-4">
        <input type="password" class="form-control" v-model="user.TEMP_PW" />
        <label>Verification code</label>
      </div>

      <div ref="two" class="check red" role="alert">&nbsp;</div>
    </div>

    <div class="buttons">
      <div class="row">
        <div class="col mb-3">
          <button type="button" class="btn btn-outline-dark btn-lg rounded-pill w-100" @click="backToFindPwdClick">
            Back
          </button>
        </div>

        <div class="col mb-3">
          <button
              type="button"
              class="btn btn-dark btn-lg rounded-pill w-100"
              :disabled="user.TEMP_PW === ''"
              @click="comparePwdClick"
          >
            <span class="spinner-border spinner-border-sm" v-if="loading.step2"></span>
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 3단계 -->
  <div class="stepThree fixed-layout" v-show="three">

    <div class="content">
      <div class="title mt-3 mb-4">
        <p class="h2"><b>Reset your password</b></p>
      </div>

      <div class="text mb-4">
        <p class="h6">Reset your password and sign in again.</p>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" readonly v-model="user.USER_ID" />
        <label>Username</label>
      </div>

      <div class="form-floating mb-3">
        <input type="password" class="form-control" v-model="user.USER_PW" :disabled="show.finish" />
        <label>Password</label>
      </div>

      <div class="form-floating mb-4">
        <input type="password" class="form-control" v-model="user.USER_PW2" :disabled="show.finish" />
        <label>Confirm password</label>
      </div>

      <div ref="three" class="check red" role="alert">&nbsp;</div>
    </div>

    <div class="buttons">
      <div class="row">
        <div class="col mb-3" v-if="!show.finish">
          <button type="button" class="btn btn-outline-dark btn-lg rounded-pill w-100" @click="backToComparePwdClick">
            Back
          </button>
        </div>

        <div class="col mb-3" v-if="show.resetPwd">
          <button type="button" class="btn btn-dark btn-lg rounded-pill w-100" @click="resetPwdClick">
            <span class="spinner-border spinner-border-sm" v-if="loading.step3"></span>
            Reset
          </button>
        </div>

        <div class="col mb-3" v-if="show.finish">
          <button
              type="button"
              class="btn btn-dark btn-lg rounded-pill w-100"
              :disabled="!(user.USER_PW && user.USER_PW2)"
              @click="finish"
          >
            Finish
          </button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
// import { defineAsyncComponent } from "vue";
import { $global, $axios, $error } from "@/dot-ui/index.js";
import "@/assets/css/formLayout.css";
import { router } from "@/router/index.js";

// const DotIncorporationLogo = defineAsyncComponent(() =>
//   import("@/components/molecules/DotIncorporationLogo.vue")
// );

export default {
  components: {
    // DotIncorporationLogo,
  },
  data() {
    return {
      user: {
        SITE_NO: "",
        COMP_NO: "",
        USER_ID: "",
        EMAIL: "",
        TEMP_PW: "",
        USER_PW: "",
        USER_PW2: "",
      },
      fromParams: "",
      one: true,
      two: false,
      three: false,
      loading: {
        step1: false,
        step2: false,
        step3: false,
      },
      show: {
        resetPwd: true,
        finish: false,
      },
    };
  },
  created() {
    this.fromParams = $global.getUrlParams();
  },
  methods: {
    selectView(target) {
      this.one = false;
      this.two = false;
      this.three = false;

      if (target === "one") {
        this.one = true;
      }
      if (target === "two") {
        this.two = true;
      }
      if (target === "three") {
        this.three = true;
      }
    },
    // 비밀번호 찾을 계정
    async findPwdClick() {
      $error.clearForm("check");

      this.user.SITE_NO = this.fromParams.s;
      this.user.COMP_NO = this.fromParams.c;

      this.loading.step1 = true;
      let url = "/user-app/v2/users/password/reset/email/send";
      let param = this.user;
      let response = await $axios.post(url, param);
      this.loading.step1 = false;

      if (response.status === 200) {
        const json = response.data;

        if (json.RESULT_CODE === "1") {
          const email = json.EMAIL || "the above account";
          const two = this.$refs.two;
          this.user.EMAIL = email;

          two.innerHTML = `The authentication code is being sent to ${email} via email.`;
          $error.setElementAttributes(two, {
            "aria-invalid": "true",
            role: "alert",
          });

          this.selectView("two");

          document.getElementById("verification-code")?.focus();
        }

        if (json.RESULT_CODE === "0") {
          const one = this.$refs.one;

          one.innerHTML = "No matching account exists.";
          $error.setElementAttributes(one, {
            "aria-invalid": "true",
            role: "alert",
          });
          document.getElementById("step-1-user-id")?.focus();
        }
      } else {
        $error.showMessage(response, this, "one");
        $error.focus(response);
      }
    },
    // 인증코드 대조
    async comparePwdClick() {
      $error.clearForm("check");

      this.loading.step2 = true;
      let url = "/user-app/v2/users/password/reset/email/verify";
      let param = this.user;
      let response = await $axios.post(url, param);
      this.loading.step2 = false;

      if (response.status == 200) {
        // 2023-02-17 / 정태화 / 인증코드 결과처리 수정
        let json = response.data;
        if (json.RESULT_CODE == "1") {
          this.selectView("three");

          document.getElementById("password")?.focus();
        }
        if (json.RESULT_CODE === "0") {
          const two = this.$refs.two;

          two.innerHTML = "The verification code is incorrect.";
          $error.setElementAttributes(two, {
            "aria-invalid": "true",
            role: "alert",
          });
          document.getElementById("verification-code")?.focus();
        }
      } else {
        $error.showMessage(response, this, "two");
        $error.focus(response);
      }
    },
    // 비밀번호 초기화
    async resetPwdClick() {
      $error.clearForm("check");

      if (this.validateResetPwd()) {
        this.loading.step3 = true;

        this.user.SITE_NO = this.fromParams.s;
        this.user.COMP_NO = this.fromParams.c;

        let param = this.user;
        let url = "/user-app/v2/users/password/reset";
        let response = await $axios.post(url, param);
        this.loading.step3 = false;

        if (response.status == 204 || response.status == 200) {
          const three = this.$refs.three;

          three.innerHTML =
            "Your password has been successfully changed. Please login with your new password.";
          $error.setElementAttributes(three, {
            "aria-invalid": "true",
            role: "alert",
          });

          this.show.resetPwd = false;
          this.show.finish = true;
        } else {
          $error.showMessage(response, this, "three");
          $error.focus(response);
        }
      }
    },
    // 비밀번호 초기화 유효성 체크
    validateResetPwd() {
      let result = true;

      if (this.user.USER_PW == "") {
        this.$refs.three.innerHTML = "Please enter a password.";
        result = false;
      } else if (this.user.USER_PW2 == "") {
        this.$refs.three.innerHTML = "Please enter a confirm password.";
        result = false;
      } else if (this.user.USER_PW != this.user.USER_PW2) {
        this.$refs.three.innerHTML = "Passwords do not match.";
        result = false;
      }

      return result;
    },
    // 완료처리 (로그인 페이지로 이동)
    finish() {
      if (window.webkit) {
        window.webkit.messageHandlers.findPwd.postMessage("ok");
      } else {
        let fromCallback = this.fromParams.cb;
        let fromSiteNo = this.fromParams.s;
        let fromCompNo = this.fromParams.c;

        router.push({
          path: "/login",
          query: {
            cb: fromCallback,
            s: fromSiteNo,
            c: fromCompNo,
          },
        });
      }
    },
    // 뒤로가기 클릭
    cancelClick() {
      router.go(-1);
    },
    backToFindPwdClick() {
      this.user.USER_ID = null;
      this.user.TEMP_PW = null;
      this.user.EMAIL = null;
      this.selectView("one");
    },
    backToComparePwdClick() {
      this.user.USER_ID = null;
      this.user.EMAIL = null;
      this.user.USER_PW = null;
      this.user.USER_PW2 = null;
      this.selectView("two");
    },
    closeWebView() {
      if (window.webkit) {
        window.webkit.messageHandlers.findPwd.postMessage("close");
      }
    },
  },
};
</script>
